exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n._2ZhVVD9U2Zt8HbJeNlWiCr{\n    margin-bottom: 1rem;\n}\n", ""]);
// Exports
exports.locals = {
	"live_event": "_2ZhVVD9U2Zt8HbJeNlWiCr"
};